import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonComponent } from './button.component';
import { AppButtonComponent } from './appButton';

@NgModule({
  declarations: [
    ButtonComponent,
    AppButtonComponent,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ButtonComponent,
    AppButtonComponent,
  ],
})
export class ButtonModule { }
